// <s-discount-watch data-amount="{{ cart.total_discount }}" data-titles="titles joined by ||" data-cart-url="/cart.js">
// celebrates newly won discounts. The first instance on a page records the
// server-rendered total discount (cents) and applied discount titles as the
// baseline. After every cart update (standard-actions-override.js dispatches
// "cart:refreshed" on document) it reads cart.js; it celebrates only when a
// discount that was not applied before shows up (e.g. "Compre 5 ou mais" ->
// "Compre 10 ou mais", or the kit discount) AND the total discount grew. Adding
// one more piece inside the same tier (amount grows, same discount) or dropping
// to a lower tier (new title, amount shrinks) does not celebrate. It dispatches a
// bubbling "cart:discount-won" event from the element matched by `data-origin`
// (e.g. the drawer total) so <s-confetti> can burst from there.
// Module state survives the cart partial re-rendering this element.
let lastAmount = null;
/** @type {Set<string> | null} */
let lastTitles = null;
let listening = false;
let settings = { cartUrl: '/cart.js', origin: '' };

/** Titles of every discount applied to the cart (line-level and cart-level). */
function discountTitles(cart) {
  const titles = new Set();
  for (const item of cart?.items || []) {
    for (const allocation of item.line_level_discount_allocations || []) {
      const title = allocation?.discount_application?.title;
      if (title) titles.add(title);
    }
  }
  for (const application of cart?.cart_level_discount_applications || []) {
    if (application?.title) titles.add(application.title);
  }
  return titles;
}

async function checkCart() {
  try {
    const response = await fetch(settings.cartUrl, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) return;
    const cart = await response.json();
    const amount = Number(cart?.total_discount) || 0;
    const titles = discountTitles(cart);
    const previousAmount = lastAmount;
    const previousTitles = lastTitles;
    lastAmount = amount;
    lastTitles = titles;
    if (previousAmount === null || previousTitles === null) return;
    const newDiscount = [...titles].some((title) => !previousTitles.has(title));
    if (!newDiscount || amount <= previousAmount) return;
    const origin = (settings.origin && document.querySelector(settings.origin)) || document.body;
    origin.dispatchEvent(new CustomEvent('cart:discount-won', { bubbles: true, detail: { amount, previous: previousAmount } }));
  } catch {
    // Network hiccup: skip the celebration, the cart itself is unaffected.
  }
}

class SDiscountWatch extends HTMLElement {
  connectedCallback() {
    settings = {
      cartUrl: this.dataset.cartUrl || settings.cartUrl,
      origin: this.dataset.origin || settings.origin,
    };
    if (lastAmount === null) lastAmount = Number.parseInt(this.dataset.amount || '0', 10) || 0;
    if (lastTitles === null) {
      lastTitles = new Set((this.dataset.titles || '').split('||').filter(Boolean));
    }
    if (!listening) {
      listening = true;
      document.addEventListener('cart:refreshed', checkCart);
    }
  }
}

if (!customElements.get('s-discount-watch')) customElements.define('s-discount-watch', SDiscountWatch);
